<template>
  <div class="cf-app-layout">
    <div class="cf-app-layout__header">
      <!-- App Header -->
      <cf-app-header :logo-navigation="logoNavigation">
        <template
          v-if="!isLoading"
          #header-left-slot
        >
          <cf-drop-down-menu-button />
        </template>

        <template
          v-if="!isLoading && (isAccountManagementEnabled || isCartManagementEnabled)"
          #header-right-slot
        >
          <cf-sign-up-button v-if="isLoginEnabed" />

          <cf-sign-in-button v-if="isLoginEnabed && !metaFieldHideSignInButton" />

          <cf-account-button v-if="isAccountButtonDisplayed" />

          <cf-cart-button v-if="isCartButtonDisplayed" />
        </template>
      </cf-app-header>
    </div>

    <!-- App Content -->
    <div class="cf-app-layout__main-content">
      <div
        v-if="isLoading"
        :class="['cf-container-full-width', { 'cf-page-loader': isLoading }]"
      >
        <div class="cf-loader" />
      </div>

      <template v-else>
        <router-view />
      </template>
    </div>

    <!-- App Footer -->
    <div class="cf-app-layout__footer">
      <cf-app-footer />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import orderAheadInitializer from '@/mixins/order-ahead-initializer';

  import CfAppHeader from '@/view/components/globals/cf-app-header/index.vue';
  import CfAppFooter from '@/view/components/globals/cf-app-footer/index.vue';
  import CfDropDownMenuButton from '@/view/components/globals/cf-app-header/cf-drop-down-menu-button/index.vue';
  import CfSignInButton from '@/view/components/globals/cf-app-header/cf-sign-in-button/index.vue';
  import CfSignUpButton from '@/view/components/globals/cf-app-header/cf-sign-up-button/index.vue';
  import CfAccountButton from '@/view/components/globals/cf-app-header/cf-account-button/index.vue';
  import CfCartButton from '@/view/components/globals/cf-app-header/cf-cart-button/index.vue';


  export default {
    name: 'OrderAheadLayout',

    metaInfo() {
      const { merchant } = this;

      return {
        titleTemplate(titleChunk) {
          return titleChunk ? `${titleChunk} | Order | ${merchant.name}` : `Order | ${merchant.name}`;
        }
      };
    },

    components: {
      CfAppHeader,
      CfAppFooter,
      CfDropDownMenuButton,
      CfSignInButton,
      CfSignUpButton,
      CfAccountButton,
      CfCartButton
    },

    mixins: [orderAheadInitializer],

    props: {
      initializer: {
        type: String,
        default: 'ORDER_AHEAD'
      },

      logoNavigation: {
        type: Object,
        default() {
          return {
            isClickable: true,
            route: 'orderMenu'
          };
        }
      },

      routerViewTransition: {
        type: Object,
        default() {
          return {
            includeTransition: false,
            name: null
          };
        }
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['currentUser', 'orderDetails']),

      metaFieldHideSignInButton() {
        return this.$route.meta?.hideSignInButton;
      },

      metaFieldHideCartButton() {
        return this.$route.meta?.hideCartButton;
      },

      isLoading() {
        return this.isOrderAheadLoading;
      },

      isUserSignedIn() {
        return this.currentUser.accountId;
      },

      isAccountManagementEnabled() {
        return this.merchant.options.signUpEnabled;
      },

      isCartManagementEnabled() {
        return !this.merchant.features['disable-ordering'];
      },

      isLoginEnabed() {
        return this.isAccountManagementEnabled && !this.isUserSignedIn;
      },

      isAccountButtonDisplayed() {
        return this.isAccountManagementEnabled && this.isUserSignedIn;
      },

      isCartButtonDisplayed() {
        return !this.metaFieldHideCartButton && this.isCartManagementEnabled;
      }
    },

    watch: {
      'orderDetails.orderType': 'initializeOrderAhead'
    },

    created() {
      this.initializeOrderAhead();
    },

    unmounted() {
      this.destroyedOrderAheadHandler();
    }
  };
</script>
